import { CustomValidator } from "../../common/validation/types";
import type { ReferenceCacheStore } from "../../../store/ReferenceCacheStore";
import { PaymentReceiptValuesType } from "./PaymentReceiptCommonStore";

/**
 * Espejo cliente (UX) de la regla del server (validateAmountCoversAtLeastOneUse):
 * el importe debe cubrir al menos un uso — la cantidad de usos posibles es la
 * división entera del importe por el precio vigente del tipo. Lee el precio del
 * cache de PaymentReceiptType (.cacheable); si el cache aún no cargó, degrada
 * al gate del server.
 */
export const amountCoversAtLeastOneUseValidator: CustomValidator<PaymentReceiptValuesType> = {
  name: "amountCoversAtLeastOneUseValidator",
  validate(values, langStore, cache?: ReferenceCacheStore) {
    const errors: Record<string, { message: string; fieldLabel: string }> = {};

    const typeId = values.showType?.id;
    const amount = Number(values.amount);
    if (!typeId || !cache || !Number.isFinite(amount)) return { errors };

    const receiptType = cache
      .getRawData("PaymentReceiptType")
      .find((r: any) => r.id === typeId);
    const unitPrice = Number(receiptType?.price);
    if (!(unitPrice > 0)) return { errors };

    if (amount < unitPrice) {
      errors.amount = {
        message: langStore.paymentReceiptAmountBelowPrice,
        fieldLabel: langStore.PaymentReceiptAmountLabel,
      };
    }

    return { errors };
  },
};
